<!-- Begin page -->
<div id="layout-wrapper" [attr.data-layout]="menuType">


  <app-blog-header></app-blog-header>

  <!-- ========== Left Sidebar Start ========== -->
  <blog-left-nav/>
  <!-- Left Sidebar End -->


  <!-- ============================================================== -->
  <!-- Start right Content here -->
  <!-- ============================================================== -->
  <div class="main-content" [ngClass]="locale==Locales.BN_BN? 'font-bn':'font-en'">

    <div id="layout-wrapper1">


      <div class="page-content">
        <div class="container-fluid">

          <router-outlet></router-outlet>
          <!-- End Page-content -->
        </div>
      </div>

    </div>


    <app-blog-footer></app-blog-footer>
  </div>
  <!-- end main content-->

</div>
<!-- END layout-wrapper -->

